import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import { BaseApiTemplateService, Core2Config } from "../../../shared";
import { EndpointContainer } from "../../../../../../../models/mongodbSchema/aggregates";


@Injectable({ providedIn: 'root' })
export class EndpointResourceService extends BaseApiTemplateService<EndpointContainer> {

  constructor(private http: HttpClient) {
    super();
    this.httpClient = http;
    this.apiUrl =  Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "endpoint"
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "endpoint"
    this.httpClient = http  
  }

}
